export class CredentialSpecialtyDefinitionModel {
  public id: string;
  public credentialDefinitionId: string;
  public CredentialDefinitionName?: string;
  public name: string;
  public description: string;
  public status: CredentialSpecialtyDefinitionStatus;

  constructor(data?: CredentialSpecialtyDefinitionModel) {
    if (!data) return;
    this.id = data.id;
    this.credentialDefinitionId = data.credentialDefinitionId;
    this.CredentialDefinitionName = data.CredentialDefinitionName;
    this.description = data.description;
    this.name = data.name;
    this.status = data.status;
  }

  isArchived(status: CredentialSpecialtyDefinitionStatus): boolean {
    return (
      CredentialSpecialtyDefinitionStatus[status] === CredentialSpecialtyDefinitionStatus.Archived
    );
  }

  static parse(data: any): CredentialSpecialtyDefinitionModel {
    if (!data) return null;
    return new CredentialSpecialtyDefinitionModel(data);
  }
}

export enum CredentialSpecialtyDefinitionStatus {
  Active = 'Active',
  Archived = 'Archived',
}
